import Profile from "@/pages/administrer/users_profiles/Profile.vue";
export default [{
    path: 'profiles',
    meta: { permissions: ["view_role"] },
    name: "AdminUserProfileProfile",
    component: Profile,

},
{
    path: 'profiles/create',
    meta: { permissions: ["create_role"] },
    name: "AdminUserProfileCreateProfile",
    component: Profile,

},
{
    path: 'profiles/:id/show',
    meta: { permissions: ["view_role"] },
    name: "AdminUserProfileShowProfile",
    component: Profile,

},]